export default __webpack_public_path__ + "static/media/Linero6Open.2bd92ab2.jpg";